import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import type { ReactionType } from "../../ReactionType.js";


export class PacketOutReaction extends PacketOut {
    private readonly reaction: ReactionType;

    constructor(reaction: ReactionType) {
        super(OutboundPacketType.REACTION);
        this.reaction = reaction;
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {
            reaction_id: this.reaction.getID(),
        };
    }
}
